export default "__VITE_ASSET__K1daVVNYU_lXF$FdA5v55g__";